/**
 * @flow
 * @relayHash 60ff3b8672350eeb22dbd0130ced4775
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type UpdatePurchaseOrderStatusInput = {|
  id: string,
  status: POStatus,
|};
export type ApprovePurchaseOrderMutationVariables = {|
  input: UpdatePurchaseOrderStatusInput
|};
export type ApprovePurchaseOrderMutationResponse = {|
  +updatePurchaseOrderStatus: {|
    +purchaseOrder: {|
      +id: string,
      +poNumber: string,
      +status: POStatus,
      +approvedBy: ?{|
        +id: string,
        +firstName: string,
        +lastName: string,
      |},
      +approvedAt: ?any,
      +updatedAt: any,
    |}
  |}
|};
export type ApprovePurchaseOrderMutation = {|
  variables: ApprovePurchaseOrderMutationVariables,
  response: ApprovePurchaseOrderMutationResponse,
|};
*/


/*
mutation ApprovePurchaseOrderMutation(
  $input: UpdatePurchaseOrderStatusInput!
) {
  updatePurchaseOrderStatus(input: $input) {
    purchaseOrder {
      id
      poNumber
      status
      approvedBy {
        id
        firstName
        lastName
      }
      approvedAt
      updatedAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePurchaseOrderStatusInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePurchaseOrderStatus",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePurchaseOrderStatusPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "purchaseOrder",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrder",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "poNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "approvedBy",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "approvedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updatedAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ApprovePurchaseOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ApprovePurchaseOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ApprovePurchaseOrderMutation",
    "id": null,
    "text": "mutation ApprovePurchaseOrderMutation(\n  $input: UpdatePurchaseOrderStatusInput!\n) {\n  updatePurchaseOrderStatus(input: $input) {\n    purchaseOrder {\n      id\n      poNumber\n      status\n      approvedBy {\n        id\n        firstName\n        lastName\n      }\n      approvedAt\n      updatedAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5b09546af1e9b16a3153c845515bd91a';
module.exports = node;
